<template>
  <div class="app-country-select">
    <Listbox v-model="selected">
      <ListboxButton class="app-country-select__button">
        <img
          :src="`/images/flags/${selected?.code}.png`"
          :alt="selected?.name"
        />

        <span>{{ selected?.name }}</span>

        <IconChevronDown />
      </ListboxButton>

      <transition name="fade">
        <ListboxOptions class="app-country-select__options">
          <ListboxOption
            v-for="language in languages"
            v-slot="{ active, selected }"
            :key="language.hash"
            :value="language"
            as="template"
          >
            <li :class="{ active: active, selected: selected }">
              <img
                :src="`/images/flags/${language.code}.png`"
                :alt="language.name"
              />

              <span>{{ language.name }}</span>

              <IconCheck v-if="selected" />
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </Listbox>
  </div>
</template>

<script setup lang="ts">
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/vue'
import IconCheck from './IconCheck.vue'
import IconChevronDown from './IconChevronDown.vue'
import { useSiteLanguages } from '~/composables/useSiteLanguages'

const { locale } = useI18n()
const { languages } = useSiteLanguages()

const selected = ref(languages.value.find((l) => l.code === locale.value) || null)

watch(selected, (value) => {
  console.log('selected', value)
  if (!value?.link) return

  window.location.href = value.link
})
</script>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-country-select {
  position: relative;
}

.app-country-select__button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0.625rem 0.75rem;
  color: $white;
  border: 1px solid $gray-300;
  border-radius: 0.125rem;
  @include transition('border-color');

  img {
    width: 2rem;
    height: 2rem;
    margin-right: 0.625rem;
    border-radius: 50%;
    object-fit: cover;
  }

  span {
    margin-right: 1.25rem;
  }

  svg {
    width: 1.25rem;
    margin-left: auto;
    color: $gray-300;
    @include transition('color');
  }

  &:hover {
    border-color: $white;

    svg {
      color: $white;
    }
  }
}

.app-country-select__options {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  margin: 0 0 0.25rem;
  padding: 0;
  color: $white;
  list-style: none;
  background-color: $black;
  border: 1px solid $gray-300;
  border-radius: 0.125rem;
  overflow: hidden;

  li {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.625rem 2.625rem 0.625rem 0.75rem;
    cursor: pointer;
    @include transition('background-color');

    img {
      width: 2rem;
      height: 2rem;
      margin-right: 0.625rem;
      border-radius: 50%;
      object-fit: cover;
    }

    svg {
      position: absolute;
      top: 50%;
      right: 0.625rem;
      width: 1.25rem;
      transform: translateY(-50%);
    }

    &.active {
      background-color: rgba($gray-300, 0.1);
    }
  }
}
</style>
